import Vue from "vue";

//----------------------------------------------------------------------------//
// FontAwesome Icons

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// Import each icon explicitly
import {
    faAsterisk,
    faCheck,
    faExclamationCircle,
    faExclamationTriangle,
    faSearch,
    faTimes
} from "@fortawesome/free-solid-svg-icons";

library.add(
    faAsterisk,
    faCheck,
    faExclamationCircle,
    faExclamationTriangle,
    faSearch,
    faTimes
);

Vue.component("fa-icon", FontAwesomeIcon);

//----------------------------------------------------------------------------//
// Boostrap-vue Components

import {
    ButtonPlugin,
    FormPlugin,
    FormCheckboxPlugin,
    FormGroupPlugin,
    FormInputPlugin,
    FormSelectPlugin,
    InputGroupPlugin,
    ModalPlugin,
    PaginationPlugin,
    TablePlugin
} from "bootstrap-vue";

Vue.use(ButtonPlugin);
Vue.use(FormPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormSelectPlugin);
Vue.use(InputGroupPlugin);
Vue.use(ModalPlugin);
Vue.use(PaginationPlugin);
Vue.use(TablePlugin);

//----------------------------------------------------------------------------//
// Custom Global Components

// Alert
Vue.component("HecAlert", () =>
    import(
        /* webpackChunkName: "HecAlert", webpackPrefetch: true */ "./components/global/HecAlert.vue"
    )
);

//----------------------------------------------------------------------------//
// Styles

import "./styles/index.scss";

//----------------------------------------------------------------------------//
// Bootstrap App

import App from "./App.vue";

Vue.config.productionTip = false;

new Vue({
    render: h => h(App)
}).$mount("#app");
